import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import Roles from "./Roles";
import ProjectRoles from "./ProjectRoles";
import React from "react";
import { ProjectRoles as ProjectRolesType, Roles as RolesType, Projects } from "../../redux/types/firebase";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    roles: {
        flexGrow: 1,
        paddingRight: theme.spacing(1),
        maxHeight: 350,
        overflowY: "auto",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    },
}));

interface Props
{
    onRolesChange: (roles: RolesType) => void
    projects: Projects,
    roles: RolesType
}
export function UserRoles({ onRolesChange, projects, roles }: Props)
{
    const classes = useStyles();

    return (
        <Box display="flex" margin={1}>
            <Box>
                <Roles onRolesChange={onRolesChange} roles={roles} />
            </Box>
            <Box className={classes.roles}>
                {Object.keys(projects || {}).map(project =>
                {
                    const handleProjectRolesChanged = (projectRoles: RolesType) =>
                    {
                        onRolesChange({
                            ...roles,
                            [project]: projectRoles
                        });
                    };

                    return (
                        <Accordion key={project}>
                            <AccordionSummary>
                                <Typography>{projects[project].name}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <ProjectRoles
                                    project={project} onRolesChange={handleProjectRolesChanged}
                                    roles={(roles as ProjectRolesType)[project]} />
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </Box>
        </Box>
    );
}